import { connectRefinementList, Highlight } from 'react-instantsearch-dom'
import { useTranslation } from 'next-i18next'
import styles from './search-facets.module.scss'
import CustomRangeSlider from '@components/category/range-slider'

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
  title,
  position,
}: any) => {
  const { t: translate } = useTranslation('common')

  return (
    <div className={styles.refinements__item}>
      <h2 className="mb-0" id={`heading${title.replaceAll(' ', '')}`}>
        <button
          className={`group relative flex w-full items-center rounded-none border-0 px-5 py-4 text-left capitalize text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:bg-white [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)]`}
          type="button"
          data-te-collapse-init
          data-te-collapse-collapsed={position !== 'first'}
          data-te-target={`#collapse${title.replaceAll(' ', '')}`}
          aria-expanded={position === 'first'}
          aria-controls={`collapse${title.replaceAll(' ', '')}`}
        >
          {title}
          <span className="-mr-1 ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:mr-0 group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </span>
        </button>
      </h2>
      <div
        id={`collapse${title.replaceAll(' ', '')}`}
        className={position === 'first' ? '' : '!visible hidden'}
        data-te-collapse-item={position !== 'first'}
        aria-labelledby={`heading${title.replaceAll(' ', '')}`}
        data-te-parent="#search_filters"
      >
        <div className="px-5 py-4">
          <ul className={styles.facet_list}>
            {items
              .filter((i: any) => i.label !== '')
              .map((item: any) => (
                <li
                  key={item.label}
                  className={`${styles.refinements__item__option}`}
                >
                  <a
                    href={createURL(item.value)}
                    style={{ fontWeight: item.isRefined ? 'bold' : '' }}
                    onClick={(event) => {
                      event.preventDefault()
                      refine(item.value)
                    }}
                  >
                    {isFromSearch ? (
                      <>
                        {/* @ts-ignore */}
                        <Highlight attribute="label" hit={item} />
                      </>
                    ) : (
                      <span
                        className="name"
                        dangerouslySetInnerHTML={{
                          __html:
                            item.label.toLowerCase() == 'fsd_us'
                              ? translate('text-facet-fsd-us')
                              : item.label.toLowerCase(),
                        }}
                      ></span>
                    )}{' '}
                    <span className={styles.facet_count}>{item.count}</span>
                  </a>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

const CustomRefinementList = connectRefinementList(RefinementList)

const sortByBoolean: any['sortBy'] = (a, b) => {
  return b ? -1 : 1
}

const sortByNumber: any['sortBy'] = (a, b) => {
  return Number(a) < Number(b) ? -1 : 1
}

const sortByName: any['sortBy'] = (a, b) => {
  return a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1
}

export function SearchFacets({ locale, subCatLevel, catName }: any) {
  const { t: translate } = useTranslation('common')
  const cat_level = subCatLevel || 1
  const cat_title =
    cat_level > 1 && catName
      ? `${translate('text-categories-before')} ${catName} ${translate(
          'text-categories-after',
        )}`
      : translate('text-department')

  return (
    <div className={`search_filters ${styles.refinements}`} id="search_filters">
      {/* @ts-ignore */}
      <CustomRefinementList
        attribute={`category_l${cat_level}`}
        /* @ts-ignore */
        title={cat_title}
        position="first"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        id="country"
        attribute="attributes.country_of_manufacture"
        /* @ts-ignore */
        title={translate('text-origin')}
        sortBy={sortByNumber}
        position="middle"
        searchable={false}
      />

      <div className={styles.refinements__item}>
        <h2 className="mb-0" id={`headingPrice`}>
          <button
            className="group relative flex w-full items-center rounded-none border-0 px-5 py-4 text-left capitalize text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:bg-white [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)]"
            type="button"
            data-te-collapse-init
            data-te-collapse-collapsed
            data-te-target={`#collapsePrice`}
            aria-expanded="false"
            aria-controls={`collapsePrice`}
          >
            {translate('text-price')}
            <span className="-mr-1 ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:mr-0 group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </span>
          </button>
        </h2>
        <div
          id={`collapsePrice`}
          className="!visible hidden"
          data-te-collapse-item
          aria-labelledby={`headingPrice`}
          data-te-parent="#search_filters"
        >
          <div className="px-5 pt-4 pb-8">
            <CustomRangeSlider attribute="special_price" />
          </div>
        </div>
      </div>

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="brand"
        /* @ts-ignore */
        title={translate('text-brands')}
        sortBy={['name:asc']}
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="ships_in_days"
        /* @ts-ignore */
        title={translate('text-fulfillment-speed')}
        sortBy={sortByNumber}
        position="middle"
        transformItems={(items) =>
          items.filter((e) => (e.label += ` ${translate('text-days')}`))
        }
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="is_in_stock"
        /* @ts-ignore */
        title={translate('text-availability')}
        sortBy={sortByBoolean}
        transformItems={(items) =>
          items.filter((e) =>
            e.label === 'true'
              ? (e.label = translate('text-in-stock'))
              : (e.label = translate('text-out-of-stock')),
          )
        }
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="rating_avg"
        /* @ts-ignore */
        title={translate('text-product-review')}
        sortBy={sortByNumber}
        transformItems={(items) => items.filter((e) => (e.label += ' stars'))}
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="temperature"
        /* @ts-ignore */
        title={translate('text-temperature-description')}
        position="middle"
        transformItems={(items) =>
          items.filter((e) =>
            e.label === 'D'
              ? (e.label = translate('text-ships-dry'))
              : e.label === 'F'
              ? (e.label = translate('text-ships-frozen'))
              : (e.label = translate('text-ships-refrigerated')),
          )
        }
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="sold_as"
        /* @ts-ignore */
        title={translate('text-sold-as')}
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="stock_type"
        /* @ts-ignore */
        title={translate('text-stock-type')}
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="is_liquidation"
        /* @ts-ignore */
        title={translate('text-liquidation')}
        sortBy={sortByBoolean}
        transformItems={(items) =>
          items.filter(
            (e) =>
              (e.label =
                e.label == 'true'
                  ? translate('text-liquidation') +
                    ' ' +
                    translate('text-items')
                  : 'non-' +
                    translate('text-liquidation') +
                    ' ' +
                    translate('text-items')),
          )
        }
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="is_new_arrival"
        /* @ts-ignore */
        title={translate('text-new-arrival')}
        sortBy={sortByBoolean}
        transformItems={(items) =>
          items.filter(
            (e) =>
              (e.label =
                e.label == 'true'
                  ? translate('text-new-arrival') +
                    ' ' +
                    translate('text-items')
                  : 'non-' +
                    translate('text-new-arrival') +
                    ' ' +
                    translate('text-items')),
          )
        }
        position="middle"
        searchable={false}
      />

      {/* @ts-ignore */}
      <CustomRefinementList
        attribute="is_rebate_eligible"
        /* @ts-ignore */
        title={translate('text-rebate-eligible')}
        sortBy={sortByBoolean}
        transformItems={(items) =>
          items.filter(
            (e) =>
              (e.label =
                e.label == 'true'
                  ? translate('text-rebate-eligible') +
                    ' ' +
                    translate('text-items')
                  : 'non-' +
                    translate('text-rebate-eligible') +
                    ' ' +
                    translate('text-items')),
          )
        }
        searchable={false}
      />
    </div>
  )
}
